export interface StorageProvider {
  getItem<T = any>(key: string): T | null;
  setItem(key: string, value: unknown, expiration?: number): void;
  removeItem(key: string): void;
}
